import { getStoreInfo } from "$storePreview/api/index";
import languageUtils from "$common/utils/language";
import promotionMixin from "./promotionMixin";
import { uploadEventList } from "$common/utils/event-tracking/page";
import storage from "$common/utils/storage";

export default {
  mixins: [promotionMixin],
  data() {
    return {
      iosUrl: window?.ssrConfig?.routerConfig?.scheme?.ios ?? "superapp://h5.lifekh.com/wakeup?routepath=",
      userInfo: {},
      navBtnId: "12345678",
      weekList: [],
      hoursList: [],
      supportedPaymentsList: [],
      storeInfo: {
        storeName: { "zh-CN": "", "en-US": "" }
      },
      supportedPaymentsMap: {
        P0003: this.$t("home.CashonDelivery"),
        P0002: this.$t("home.PayOnline")
      },
      weekMap: {
        MONDAY: this.$t("home.MONDAY"),
        TUESDAY: this.$t("home.TUESDAY"),
        WEDNESDAY: this.$t("home.WEDNESDAY"),
        THURSDAY: this.$t("home.THURSDAY"),
        FRIDAY: this.$t("home.FRIDAY"),
        SATURDAY: this.$t("home.SATURDAY"),
        SUNDAY: this.$t("home.SUNDAY")
      },
      langMap: {
        zh: "zh-CN",
        km: "km-KH",
        en: "en-US",
        "zh-CN": "zh-CN",
        "km-KH": "km-KH",
        "en-US": "en-US"
      }
    };
  },
  created() {
    let htmlEL = document.documentElement;
    htmlEL.classList.add("preview-html");
  },
  computed: {
    mainStyle() {
      return (
        (this.$root.clientHeight && `height: ${this.$root.clientHeight}px;`) ||
        ""
      );
    },
    storeNo() {
      return this.$route.query.storeNo || "";
    },
    storeBgStyle() {
      let photo =
        this.storeInfo.photo ||
        "https://image.tinhnow.com/wownow/files/sit/app/MEF/BF/BD/28ea7c3617794ded85b3f4c317d378b7.jpg";
      return `background-image: url(${photo});background-size: 100% 100%;background-repeat: no-repeat`;
    },
    storeName() {
      return (
        this.storeInfo?.storeName &&
        this.storeInfo?.storeName[this.langMap[this.lang]]
      );
    },
    announcement() {
      return (
        this.storeInfo?.announcement &&
        this.storeInfo?.announcement[this.langMap[this.lang]]
      );
    },

    reviewMsg() {
      return this.lang == "zh" ? "(100条评价)" : "(100reviews)";
    },
    starMsg() {
      return this.lang == "zh" ? "5.0" : "5.0";
    },
    // 每一层的classificationName
    businessScopesMsg() {
      let { businessScopesV2 = [] } = this.storeInfo;
      let allBusiness = [];
      businessScopesV2.forEach(item => {
        allBusiness.push(item.classificationName);
        if (item.subClassifications) {
          item.subClassifications.forEach(subItem => {
            allBusiness.push(subItem.classificationName);
          });
        }
      });
      return allBusiness.join("、");
    },
    // 浏览器根据浏览器语言，忽略参数语言
    // 其他优先根据链接参数语言
    lang() {
      console.log("isWeb", this.isWeb);
      console.log(
        "sessionStorage",
        sessionStorage.getItem(`lang_${this.navBtnId}`)
      );
      // wownowapp里右上角语言按钮的值
      if (this.isWownowApp && sessionStorage.getItem(`lang_${this.navBtnId}`)) {
        return sessionStorage.getItem(`lang_${this.navBtnId}`);
      }
      if (this.isWeb) {
        return this.getNavigatorLanguage();
      }

      if (this.$route.query.lang) {
        return this.$route.query.lang;
      } else {
        return this.getNavigatorLanguage();
      }
    },
    isIOS() {
      return navigator.userAgent.toLocaleLowerCase().indexOf("mac os x") !== -1;
    },
    isPC() {
      return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    isWeb() {
      return !this.isWownowApp && !this.isMerchantApp && !this.isPC;
    },
    isMerchantApp() {
      return navigator.userAgent.toLowerCase().indexOf("supermerchant") !== -1;
    },
    isWownowApp() {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    locationQuery() {
      try {
        return this.urlQueries();
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    getAppversion() {
      if (!this.isMerchantApp) return true;
      let str = navigator.userAgent;
      let arr = str.split("/");
      return arr.length ? arr[arr.length - 1] : "0.0.0";
    },
    isShowGoApp() {
      if (!this.isMerchantApp) return true;
      let lasetVersion = "3.7.4";
      return this.compareVersion(this.getAppversion, lasetVersion);
    }
  },
  methods: {
    urlQueries() {
      let queries = {};
      try {
        let search = window.location.search.match(/\?.*(?=\b|#)/);
        if (search) {
          search = search[0].replace(/^\?/, "");
        }
        if (search) {
          // 单独处理routePath参数
          let routePathIndex =
            search.indexOf("SuperApp") !== -1
              ? search.indexOf("SuperApp")
              : search.length;
          let str1 = search.slice(0, routePathIndex);
          let routePathParam = search.slice(routePathIndex);
          str1.split("&").forEach(item => {
            const param = item.split("=");
            if (param[1]) {
              queries[param[0]] = decodeURIComponent(param[1]);
            }
          });
          queries["routePath"] = decodeURIComponent(routePathParam);
        }
        const routePath = queries.routePath || queries.routepath || "";
        if (routePath?.indexOf?.("shortID") !== -1 && queries?.shortID) {
          delete queries.shortID;
        }
        if (
          typeof window?.ssrConfig?.routerConfig?.short?.params === "object" &&
          !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)
        ) {
          queries = Object.assign(
            {},
            queries,
            window.ssrConfig.routerConfig.short.params
          );
        }
        return queries;
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    // curv : 现在版本 reqV: 需要版本
    // curv >= reqv 返回true
    compareVersion(curV, reqV) {
      if (curV && reqV) {
        //将两个版本号拆成数字
        var arr1 = curV.split("."),
          arr2 = reqV.split(".");
        var minLength = Math.min(arr1.length, arr2.length),
          position = 0,
          diff = 0;
        //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
        while (
          position < minLength &&
          (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0
        ) {
          position++;
        }
        diff = diff != 0 ? diff : arr1.length - arr2.length;
        //若curV大于reqV，则返回true
        return diff >= 0;
      } else {
        //输入为空
        console.log("版本号不能为空");
        return false;
      }
    },
    getNavigatorLanguage() {
      const navigatorLanguage = languageUtils.justGetPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf("zh") !== -1
        ? "zh"
        : navigatorLanguage.indexOf("en") !== -1
        ? "en"
        : "km";
    },
    // 获取用户信息，justget为true则不跳转登录页
    getOperator(justget = false) {
      return new Promise((resolve, reject) => {
        this.$root.timeout(() => {
          if (this.isWownowApp && window?.WOWNOW?.getUserInfo) {
            window.WOWNOW.getUserInfo({
              success: res => {
                if (res && res.loginName) {
                  storage.setItem("loginName", res.loginName);
                  storage.setItem("operatorNo", res.operatorNo);
                  this.userInfo.loginName = res.loginName;
                  this.userInfo.operatorNo = res.operatorNo;
                  resolve(res);
                }
              },
              fail: res => {
                storage.remove("loginName");
                storage.remove("operatorNo");
                console.log("get user info fail");
                if (!justget) {
                  console.log("!juseget");
                  window?.WOWNOW?.navigationToRoute({
                    route: "SuperApp://SuperApp/login"
                  });
                }
                reject();
              }
            });
          } else {
            console.error("当前环境没有js sdk");
            reject();
          }
        });
      });
    },
    // 埋点
    commonUploadEvenlist(obj) {
      const _this = this;
      const { type, businessName, event } = obj;
      // wechat 、facebook 、其他
      const fromArr = [
        {
          code: this.isWechat,
          msg: "wechat"
        },
        {
          code: this.isFaceBook,
          msg: "facebook"
        },
        {
          code: !this.isWechat && !this.isFaceBook,
          msg: "其他"
        }
      ];
      uploadEventList([
        {
          businessName,
          eventGroup: "other",
          event,
          ext: {
            type,
            deviceId: storage.getItem("device-id"),
            time: new Date().getTime(),
            thirdPartyType: fromArr.filter(i => i.code)[0].msg
          },
          operatorNo: _this.isWownowApp
            ? _this.userInfo.operatorNo || null
            : null
        }
      ]);
    },
    // 获取门店
    async ajaxGetStore() {
      try {
        Vue.filter("loading")(true);
        const { data, rspCd } = await getStoreInfo({
          storeNo: this.storeNo,
          location: {
            lat: "",
            lon: ""
          }
        });
        if (rspCd === "00000") {
          Vue.filter("loading")(false);
          console.log("data", data);
          this.handlePromotionData(data);
          // "businessHours":[["10:00","14:30"],["18:00","02:00"]],
          // businessDays["MONDAY","TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"]
          this.weekList = data.businessDays.map(item => {
            return this.weekMap[item];
          });
          this.hoursList = data.businessHours.map(item => {
            let str = item.length >= 2 ? item[0] + "-" + item[1] : "undefined";
            return str;
          });
          this.supportedPaymentsList = data.supportedPayments.map(item => {
            return this.supportedPaymentsMap[item];
          });
          this.$set(this, "storeInfo", data);
        }
      } catch (err) {
        console.log("err", err);
        Vue.filter("loading")(false);
      }
    },
    handleSetNav() {
      if (this.isWownowApp) {
        console.log(
          "handleSetNav-- isWownowApp",
          this.isWownowApp,
          window?.WOWNOW
        );
        this.$root.timeout(() => {
          // 设置返回按钮样式
          window?.WOWNOW?.setWebViewBackStyle({
            style: "goBack",
            success: () => {
              console.log("goback");
            }
          });
          // 移除所有按钮
          window.WOWNOW.removeAllNavButton();
          window.webViewHost.on(
            "navigationBar.rightButton.onclick",
            ({ id }) => {
              console.log("on click id: " + id);
              let newLang = this.lang == "zh" ? "en" : "zh";
              this.$router.replace({
                name: window.location.pathname.includes("/store-info-page")
                  ? "store-info-page"
                  : "store-preview",
                query: {
                  storeNo: this.$route.query.storeNo,
                  lang: newLang
                }
              });
              sessionStorage.setItem(`lang_${this.navBtnId}`, newLang);
              this.$router.go(0);
            }
          );
          let enImg =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB1UlEQVRoQ+2ZQU7DMBBFx4TehWWUuUC74Qqw4AwcCiEEp6B75Cg7roHEssSDLGHkOHEmbprYrppl7dj/zZ+x4qmAzB+RuX64AMR28OJA8g5UVXUnhHgGgOuVxf4Q0UNd129j+46mUETxRjML4QVIQPwkiEGAhMSzED0Aj3jWylPWR4iGHgAiHpyCXVW8CYQPQkq5sYM1BED2BCK6506CU0bfXusP4tX+TUrZ0cwCuC8sJda3LiJ2AjobwF3Qt7HZyJ3ftu2uaZq9eY8TyI0HOzAXAAD2UspdzgBgu8BFmBuP4YAO/r8LnEBufDYAV+S+lDMucAK58WgAxgVOIDc+GyD0FLLnaxeKongfO+eTBtAuAMA2N4Ce6KwAhtImKkDoKaTnI6LO+07qGAh3vcVr4BiAsiy3bvFGAwg9haxvpEEXVnfgWACfC9kAaPChWsgKYMiFxQGyu9DkeKXM+1If0tJYKp1CNJxfY4vpyywV9LF1R/tS59vctZ0AgBchxNXK4Z/UEZz0Dw0ifgLAjQEgog+l1G3TNF8rQ/W2CwZISbymCQJITXwQABF9p5I2dh5NcqCqqiel1GMKOe8WwSQARNxIKfUnRnLPJIDkVFuCLgCx3cnegV+GSjVPvqi69QAAAABJRU5ErkJggg==";
          let zhImg =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAHlBMVEUAAAAzMzMwMDAyMjIyMjIyMjIzMzMzMzMyMjIzMzPTm5zUAAAACXRSTlMABRBXosrX+/3iRGayAAAAgklEQVQ4y2NgGLTAfCYKKIaJM1eiSkw3wK4BrgVdA1yLOUIvTCFESyXCNpjR08H0zJlQDTNnQrVAGTA+BoNMCYRbaSmBwLSToL0/qBXsOKIWZ2LAmXxwJjicSRR3omawwJENGNhmTlXAmnHYZgZhz1FsODQwsOHQwMCCQwMD4wAVCgDfOdbvc0vKrAAAAABJRU5ErkJggg==";
          window.WOWNOW.addNavRightButton({
            imageBase64: this.lang === "zh" ? zhImg : enImg,
            id: this.navBtnId
          });
        }, 500);
      }
    }
  }
};
